export default __webpack_public_path__ + "static/media/ic_right_1.0a0db3dc.svg";